// src/pages/LavorazioniCrea.jsx
import React, { useEffect, useState } from 'react';
import { authFetch } from '../utils/authFetch';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card } from '../components/ui';

const API_BASE = '/api';

const LavorazioniCrea = () => {
  const [myRole, setMyRole] = useState(localStorage.getItem('role') || null);
  const [assignableUsers, setAssignableUsers] = useState([]);
  const [clientUsers, setClientUsers] = useState([]);     // ✅ lista clienti (role=cliente)
  const [customerUserId, setCustomerUserId] = useState(''); // ✅ cliente selezionato

  const [externalCode, setExternalCode] = useState('');
  const [internalCode, setInternalCode] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [place, setPlace] = useState('');
  const [description, setDescription] = useState('');
  const [type, setType] = useState('intervento');
  const [receivedAt, setReceivedAt] = useState('');
  const [assignedTo, setAssignedTo] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [maintenanceDate, setMaintenanceDate] = useState('');

  // stato preventivo (solo per interventi)
  const [preventivoStatus, setPreventivoStatus] = useState('');
  const [orderStatus, setOrderStatus] = useState('');

  const [equipmentType, setEquipmentType] = useState('');
  const [equipmentMaker, setEquipmentMaker] = useState('');
  const [equipmentModel, setEquipmentModel] = useState('');
  const [equipmentSerial, setEquipmentSerial] = useState('');
  const [equipmentInventory, setEquipmentInventory] = useState('');
  const [equipmentPresidio, setEquipmentPresidio] = useState('');

  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [rifPreventivo, setRifPreventivo] = useState('');
  const [consuntivoStatus, setConsuntivoStatus] = useState('');

  const [materialeArrivato, setMaterialeArrivato] = useState('');  
  const [importoPreventivo, setImportoPreventivo] = useState('');
  const [manutenzioneConPreventivo, setManutenzioneConPreventivo] = useState(false);
  
  const [rifOrdineCliente, setRifOrdineCliente] = useState('');

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  // Arrivo da "Lavorazioni generate": il form si precompila con la proposta
  const generataId = searchParams.get('generata');
  const [generata, setGenerata] = useState(null);
  const isManager =
    myRole === 'admin' || myRole === 'segreteria' || myRole === 'gestione';

  // helper per riconoscere l'utente "Da Assegnare"
  const isDaAssegnareUser = (u = {}) => {
    const username = (u.username || '').toLowerCase();
    const fullName = `${u.nome || ''} ${u.cognome || ''}`.toLowerCase();
    return (
      username.includes('da assegnare') || fullName.includes('da assegnare')
    );
  };

  // utenti assegnabili
  const loadAssignableUsers = async () => {
    try {
      const res = await authFetch(`${API_BASE}/users`);
      if (!res.ok) return;
      const data = await res.json();
      const allowedRoles = ['admin', 'gestione', 'tecnico', 'Tecnico'];

      const list = (data || []).filter((u) => allowedRoles.includes(u.role));
      setAssignableUsers(list);
      const clients = (data || []).filter((u) => u.role === 'cliente');
      setClientUsers(clients);


      // ✅ imposta di default "Da Assegnare" se esiste e se non hai già selezionato qualcuno
      if (!assignedTo) {
        const daUser = list.find(isDaAssegnareUser);
        if (daUser) {
          setAssignedTo(daUser._id);
        }
      }
    } catch (err) {
      console.error('Errore caricamento utenti:', err);
    }
  };

  // prossimo codice interno
  const fetchNextInternalCode = async (selectedType) => {
    try {
      const res = await authFetch(
        `${API_BASE}/work/next-code?type=${encodeURIComponent(selectedType)}`
      );
      if (!res.ok) return;
      const data = await res.json();
      if (data.internalCode) setInternalCode(data.internalCode);
    } catch (err) {
      console.error('Errore recupero codice interno:', err);
    }
  };

  useEffect(() => {
    const storedRole = localStorage.getItem('role');
    if (storedRole) setMyRole(storedRole);
    loadAssignableUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isManager && type) fetchNextInternalCode(type);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, isManager]);

  // precompilazione dalla proposta letta nella mail
  useEffect(() => {
    if (!generataId || !isManager) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await authFetch(`${API_BASE}/generated-work/${generataId}`);
        if (!res || !res.ok) {
          setError('Proposta non trovata: compila il form a mano.');
          return;
        }
        const g = await res.json();
        if (cancelled) return;
        const p = g.proposal || {};
        const mail = g.inboundMail || {};

        setGenerata(g);
        if (p.type) setType(p.type);
        const ricevuta = mail.sentAt || mail.receivedAt;
        if (ricevuta) {
          const d = new Date(ricevuta);
          if (!Number.isNaN(d.getTime())) {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            setReceivedAt(`${yyyy}-${mm}-${dd}`);
          }
        }
        setCompanyName(p.companyName || '');
        setCustomerUserId(g.match?.customerUserId?._id || '');
        setCustomerPhone(p.customerPhone || '');
        setPlace(p.place || '');
        setDescription(p.description || '');
        setEquipmentType(p.equipmentType || '');
        setEquipmentMaker(p.equipmentMaker || '');
        setEquipmentModel(p.equipmentModel || '');
        setEquipmentSerial(p.equipmentSerial || '');
        setEquipmentInventory(p.equipmentInventory || '');
        setEquipmentPresidio(p.equipmentPresidio || '');
        setRifPreventivo(p.rifPreventivo || '');
        if (p.rifOrdineCliente) {
          setRifOrdineCliente(p.rifOrdineCliente);
          setOrderStatus('Ordine ricevuto');
        }
      } catch (err) {
        console.error('Errore caricamento proposta:', err);
        if (!cancelled) setError('Errore nel caricamento della proposta.');
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generataId, isManager]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!isManager) {
      setError('Non sei autorizzato a creare lavorazioni.');
      return;
    }

    if (!type || !receivedAt) {
      setError('Tipo e data ricezione sono obbligatori.');
      return;
    }

    
    // per gli INTERVENTI il campo preventivo è obbligatorio
    if (type === 'intervento' && !preventivoStatus) {
      setError(
        'Per gli interventi devi indicare se il preventivo è da fare o già fatto.'
      );
      return;
    }
    if (
      type === 'intervento' &&
      preventivoStatus === 'A consuntivo' &&
      !consuntivoStatus
    ) {
      setError('Devi indicare Si o No per A consuntivo');
      return;
    }

    // 🔹 per gli INTERVENTI lo stato ordine è obbligatorio
    if (type === 'intervento' && !orderStatus) {
      setError(
        'Per gli interventi devi indicare lo stato ordine.'
      );
      return;
    }

    if (
      type === 'intervento' &&
      orderStatus === 'Ordine ricevuto' &&
      !rifOrdineCliente.trim()
    ) {
      setError('Se lo stato ordine è "Ricevuto" devi inserire il Rif. ordine.');
      return;
    }
    
    if (mustShowMaintenanceDate && !maintenanceDate) {
      setError('Se assegni la lavorazione ad un tecnico devi inserire la data di intervento.');
      return;
    }




    const payload = {
      externalCode: externalCode.trim() || undefined,
      companyName: companyName.trim() || undefined,
      customerUserId: customerUserId || undefined,
      customerPhone:
        type === 'intervento' ? customerPhone.trim() || undefined : undefined,
      place: place.trim() || undefined,
      description: description.trim() || undefined,
      type,
      receivedAt,
      assignedTo: assignedTo || undefined,
      dates: mustShowMaintenanceDate ? [maintenanceDate] : [],
      rifPreventivo: rifPreventivo.trim() || undefined,
      manutenzioneConPreventivo:
        type === 'manutenzione' ? manutenzioneConPreventivo : false,
      equipmentType: equipmentType.trim() || undefined,
      equipmentMaker: equipmentMaker.trim() || undefined,
      equipmentModel: equipmentModel.trim() || undefined,
      equipmentSerial: equipmentSerial.trim() || undefined,
      equipmentInventory: equipmentInventory.trim() || undefined,
      equipmentPresidio: equipmentPresidio.trim() || undefined,
      importoPreventivo:
        (type === 'intervento' || (type === 'manutenzione' && manutenzioneConPreventivo)) &&
        String(importoPreventivo || '').trim() !== ''
          ? String(importoPreventivo).trim()
          : undefined,
      materialeArrivato:
        type === 'intervento'
          ? materialeArrivato || undefined
          : undefined,
      // È OK
      preventivoStatus:
        type === 'intervento' ? preventivoStatus : undefined,

      //  MANCAVA
      consuntivoStatus:
        type === 'intervento' && preventivoStatus === 'A consuntivo'
          ? consuntivoStatus
          : undefined,

      // GIÀ OK
      orderStatus:
        type === 'intervento' ? orderStatus : undefined,
      
      rifOrdineCliente:
        type === 'intervento' && orderStatus === 'Ordine ricevuto'
          ? rifOrdineCliente.trim() || undefined
          : undefined,
    };

    try {
      const res = await authFetch(`${API_BASE}/work`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      const data = await res.json().catch(() => null);

      if (!res.ok) {
        setError(
          data?.error || 'Errore durante la creazione della lavorazione.'
        );
        return;
      }

      setMessage(
        `Lavorazione creata con successo. Codice interno: ${
          data.workOrder?.internalCode || ''
        }`
      );
      setError('');

      // se veniva da una proposta letta nella mail, la segniamo convertita
      if (generataId && data.workOrder?._id) {
        try {
          await authFetch(`${API_BASE}/generated-work/${generataId}/convert`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ workOrderId: data.workOrder._id }),
          });
        } catch (err) {
          console.error('Errore collegamento proposta:', err);
        }
        setTimeout(() => navigate('/lavorazioni/generate'), 1500);
        return;
      }

      // reset campi testo
      setExternalCode('');
      setCompanyName('');
      setCustomerUserId('');
      setPlace('');
      setDescription('');
      setCustomerPhone('');
      setEquipmentType('');
      setEquipmentMaker('');
      setEquipmentModel('');
      setEquipmentSerial('');
      setEquipmentInventory('');
      setEquipmentPresidio('');
      setPreventivoStatus('');
      setConsuntivoStatus('');
      setOrderStatus('');
      setRifOrdineCliente('');
      setMaintenanceDate('');
      setRifPreventivo('');
      setMaterialeArrivato('');
      setManutenzioneConPreventivo(false);
      setImportoPreventivo('');

      //// ✅ dopo il salvataggio, rimetti di nuovo "Da Assegnare"
      //const daUser = assignableUsers.find(isDaAssegnareUser);
      //if (daUser) {
      //  setAssignedTo(daUser._id);
      //} else {
      const daUser = assignableUsers.find(isDaAssegnareUser);
      setAssignedTo(daUser ? daUser._id : '');
      
      //}
//
      fetchNextInternalCode(type);
    } catch (err) {
      console.error('Errore creazione lavorazione:', err);
      setError('Errore nella richiesta al server.');
    }
  };

  if (!isManager) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center bg-gray-100 px-4">
        <Card className="shadow-md p-6 max-w-md w-full text-center">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            Accesso non autorizzato
          </h2>
          <p className="text-sm text-gray-600 mb-4">
            Solo <strong>Admin</strong>, <strong>Segreteria</strong> e{' '}
            <strong>Gestione</strong> possono creare lavorazioni.
          </p>
          <button
            onClick={() => navigate('/lavorazioni')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 transition"
          >
            Torna alle lavorazioni
          </button>
        </Card>
      </div>
    );
  }

  const selectedAssignedUser = assignableUsers.find((u) => u._id === assignedTo);
const isDaAssegnareSelected = selectedAssignedUser
  ? isDaAssegnareUser(selectedAssignedUser)
  : false;

const mustShowMaintenanceDate = !!assignedTo && !isDaAssegnareSelected;

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-3 md:px-6 flex justify-center">
      <div className="w-full max-w-4xl space-y-6">
        <Card className="shadow-sm px-4 py-4 md:px-6 md:py-5 flex items-center justify-between">
          <div>
            <h1 className="text-xl md:text-2xl font-semibold text-gray-800 mb-1">
              Crea e assegna lavorazione
            </h1>
            <p className="text-xs md:text-sm text-gray-500">
              Inserisci una nuova lavorazione e assegnala ad un utente.
            </p>
          </div>
          <button
            onClick={() => navigate('/lavorazioni')}
            className="px-3 py-1.5 rounded-lg bg-gray-100 text-gray-700 text-xs font-medium hover:bg-gray-200"
          >
            Indietro
          </button>
        </Card>

        {(message || error) && (
          <Card className="shadow-sm px-4 py-3 md:px-6">
            {message && (
              <p className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-lg px-3 py-2 mb-1">
                {message}
              </p>
            )}
            {error && (
              <p className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
                {error}
              </p>
            )}
          </Card>
        )}

        <Card className="shadow-sm p-4 md:p-6">
          {generata && (
            <div className="mb-4 rounded-lg bg-indigo-50 border border-indigo-200 px-3 py-2 text-xs text-indigo-900 flex flex-col md:flex-row md:items-center md:justify-between gap-2">
              <span>
                Campi precompilati dalla mail di{' '}
                <strong>
                  {generata.inboundMail?.from?.name || generata.inboundMail?.from?.address || 'mittente sconosciuto'}
                </strong>
                {generata.inboundMail?.subject ? `: "${generata.inboundMail.subject}"` : ''}.
                Controlla tutto prima di salvare.
              </span>
              <button
                type="button"
                onClick={() => navigate('/lavorazioni/generate')}
                className="shrink-0 px-3 py-1 rounded-lg bg-white border border-indigo-200 text-indigo-700 font-medium hover:bg-indigo-100"
              >
                Torna alle proposte
              </button>
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-5 text-sm">
            {/* codici + tipo + data */}
            <div className="grid md:grid-cols-4 gap-4">
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Codice esterno
                </label>
                <input
                  type="text"
                  value={externalCode}
                  onChange={(e) => setExternalCode(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Es. codice commessa cliente"
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Codice interno (auto)
                </label>
                <input
                  type="text"
                  value={internalCode}
                  readOnly
                  className="w-full px-3 py-2 border rounded-lg bg-gray-50 text-gray-700"
                />
                <p className="mt-1 text-[11px] text-gray-400">
                  Esempio: M25-00000, I25-00001
                </p>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Tipo lavorazione <span className="text-red-500">*</span>
                </label>
                <select
                  value={type}
                  onChange={(e) => {
                    const newType = e.target.value;
                    setType(newType);

                    if (newType !== 'intervento') {
                      setPreventivoStatus('');
                      setConsuntivoStatus('');
                      setOrderStatus('');
                      setRifOrdineCliente('');
                    }

                    if (newType !== 'manutenzione') {
                      setManutenzioneConPreventivo(false);
                      setRifPreventivo('');
                    }

                    if (
                      newType !== 'intervento' &&
                      !(newType === 'manutenzione' && manutenzioneConPreventivo)
                    ) {
                      setImportoPreventivo('');
                    };
                  }}

                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                  required
                >
                  <option value="intervento">Intervento</option>
                  <option value="manutenzione">Manutenzione</option>
                </select>
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Data ricezione richiesta <span className="text-red-500">*</span>
                </label>
                <input
                  type="date"
                  value={receivedAt}
                  onChange={(e) => setReceivedAt(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  required
                />
              </div>
            </div>

            {/* azienda/luogo */}
            <div className="grid md:grid-cols-3 gap-4">
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Azienda / Cliente
                </label>
                <input
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Es. Azienda XYZ S.r.l."
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Luogo intervento
                </label>
                <input
                  type="text"
                  value={place}
                  onChange={(e) => setPlace(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Es. Roma (RM) - Via..."
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Account Cliente (opzionale)
                </label>
                <select
                  value={customerUserId}
                  onChange={(e) => setCustomerUserId(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                >
                  <option value="">— Nessun cliente —</option>
                  {clientUsers.map((c) => (
                    <option key={c._id} value={c._id}>
                      {(c.nome || '').trim() || c.username} ({c.matricola || 'C****'})
                    </option>
                  ))}
                </select>
                <p className="mt-1 text-[11px] text-gray-400">
                  Se selezioni un cliente, vedrà questa lavorazione nella sua dashboard.
                </p>
              </div>
                
            </div>
            
            {/* telefono cliente (solo interventi) */}
            {type === 'intervento' && (
              <div className="mt-4">
                <label className="block text-gray-700 font-medium mb-1">
                  Telefono cliente
                </label>
                <input
                  type="tel"
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Es. 333 1234567"
                />
              </div>
            )}
            

            {/* Dati apparecchiatura */}
            <div className="border-t border-gray-200 pt-4 mt-4">
              <h3 className="text-sm font-semibold text-gray-800 mb-3">
                Dati apparecchiatura
              </h3>
              <div className="grid md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Tipo
                  </label>
                  <input
                    type="text"
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                    placeholder="Es. Camera climatica"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Produttore
                  </label>
                  <input
                    type="text"
                    value={equipmentMaker}
                    onChange={(e) => setEquipmentMaker(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                    placeholder="Es. Angelantoni"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Modello
                  </label>
                  <input
                    type="text"
                    value={equipmentModel}
                    onChange={(e) => setEquipmentModel(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                    placeholder="Es. CH250"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-3 gap-4 mt-3">
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Seriale
                  </label>
                  <input
                    type="text"
                    value={equipmentSerial}
                    onChange={(e) => setEquipmentSerial(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Inventario
                  </label>
                  <input
                    type="text"
                    value={equipmentInventory}
                    onChange={(e) => setEquipmentInventory(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  />
                </div>
                <div>
                  <label className="block text-gray-700 font-medium mb-1">
                    Presidio
                  </label>
                  <input
                    type="text"
                    value={equipmentPresidio}
                    onChange={(e) => setEquipmentPresidio(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                    placeholder="Es. Terni, Perugia..."
                  />
                </div>
              </div>
            </div>

            {/* descrizione */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Note Generali
              </label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                rows={3}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 resize-y"
                placeholder="Descrivi brevemente l'intervento o la manutenzione."
              />
            </div>

            {/* assegnatario */}
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Assegna a
              </label>
              <select
                value={assignedTo}
                onChange={(e) => {
                  const val = e.target.value;
                  setAssignedTo(val);
                
                  const u = assignableUsers.find((x) => x._id === val);
                  if (!val || (u && isDaAssegnareUser(u))) {
                    setMaintenanceDate('');
                  }
                }}
                className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
              >
                <option value="">Seleziona un utente</option>
                {assignableUsers.map((u) => (
                  <option key={u._id} value={u._id}>
                    {u.nome || u.cognome
                      ? `${u.nome || ''} ${u.cognome || ''}`.trim()
                      : u.username}{' '}
                    ({u.role})
                  </option>
                ))}
              </select>
              <p className="mt-1 text-[11px] text-gray-400">
                Puoi assegnare la lavorazione ai tecnici. Per
                lasciarla aperta, usa l&apos;utente &quot;Da Assegnare&quot;.
              </p>
            </div>

            {mustShowMaintenanceDate && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Data intervento <span className="text-red-500">*</span>
                </label>

                <input
                  type="date"
                  value={maintenanceDate}
                  onChange={(e) => setMaintenanceDate(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                  required
                />

                <p className="mt-1 text-[11px] text-gray-400">
                  Obbligatoria quando assegni la lavorazione ad un utente (diverso da "Da Assegnare").
                </p>
              </div>
            )}


            {/* Preventivo (solo interventi) */}
            {type === 'intervento' && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Stato preventivo <span className="text-red-500">*</span>
                </label>
                <select
                  value={preventivoStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPreventivoStatus(value);

                    if (value !== 'A consuntivo') {
                      setConsuntivoStatus('');
                    }
                  }}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                  required={type === 'intervento'}
                >
                  <option value="">Seleziona stato preventivo</option>
                  <option value="Preventivo da fare">Preventivo da fare</option>
                  <option value="Preventivo fatto">Preventivo fatto</option>
                  <option value="A consuntivo">A consuntivo</option>
                  <option value="Contratto">Contratto</option>
                </select>
                {type === 'intervento' && preventivoStatus === 'A consuntivo' && (
                  <div className="mt-3">
                    <label className="block text-gray-700 font-medium mb-1">
                      A consuntivo
                    </label>
                    <select
                      value={consuntivoStatus}
                      onChange={(e) => setConsuntivoStatus(e.target.value)}
                      className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                      required
                    >
                      <option value="">Seleziona</option>
                      <option value="Si">Sì</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                )}
                <p className="mt-1 text-[11px] text-gray-400">
                  Campo richiesto solo per gli interventi; per le manutenzioni non
                  viene considerato.
                </p>
              </div>
            )}

            {/* Manutenzione con preventivo */}
            {type === 'manutenzione' && (
              <div>
                <label className="block text-gray-700 font-medium mb-2">
                  Manutenzione da effettuare con preventivo?
                </label>
            
                <div className="flex items-center gap-3">
                  <button
                    type="button"
                    onClick={() => {
                      const next = !manutenzioneConPreventivo;
                      setManutenzioneConPreventivo(next);
                      if (!next) setRifPreventivo('');
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition ${
                      manutenzioneConPreventivo ? 'bg-emerald-600' : 'bg-gray-300'
                    }`}
                  >
                    <span
                      className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${
                        manutenzioneConPreventivo ? 'translate-x-5' : 'translate-x-1'
                      }`}
                    />
                  </button>
                    
                  <span className="text-sm text-gray-700">
                    {manutenzioneConPreventivo ? 'Sì' : 'No'}
                  </span>
                </div>
              </div>
            )}


            {/* Rif. preventivo */}
            {(
              type === 'intervento' ||
              (type === 'manutenzione' && manutenzioneConPreventivo)
            ) && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Rif. preventivo
                </label>
                <input
                  type="text"
                  value={rifPreventivo}
                  onChange={(e) => setRifPreventivo(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Inserire se esistente"
                />
              </div>
            )}

            {/* Imp. preventivo */}
            {(
              type === 'intervento' ||
              (type === 'manutenzione' && manutenzioneConPreventivo)
            ) && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Importo preventivo
                </label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  value={importoPreventivo}
                  onChange={(e) => setImportoPreventivo(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Es. 1250.00"
                />
                <p className="mt-1 text-[11px] text-gray-400">
                  Questo valore verrà copiato automaticamente nella contabilità come "Imp. preventivo".
                </p>
              </div>
            )}

            {/* Stato ordine (solo interventi) */}
            {type === 'intervento' && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Stato ordine <span className="text-red-500">*</span>
                </label>
                <select
                  value={orderStatus}
                  onChange={(e) => {
                    const value = e.target.value;
                    setOrderStatus(value);
                    if (value !== 'Ordine ricevuto') {
                      setRifOrdineCliente('');
                    }
                  }}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                  required={type === 'intervento'}
                >
                  <option value="">Seleziona stato ordine</option>
                  <option value="Ordine ricevuto">Ricevuto</option>
                  <option value="Ordine non ricevuto">Non ricevuto</option>
                </select>
                <p className="mt-1 text-[11px] text-gray-400">
                  Campo richiesto solo per gli interventi; per le manutenzioni non viene considerato.
                </p>
              </div>
            )}


            {type === 'intervento' && orderStatus === 'Ordine ricevuto' && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Rif. ordine <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={rifOrdineCliente}
                  onChange={(e) => setRifOrdineCliente(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500"
                  placeholder="Inserire riferimento ordine cliente"
                  required
                />
                <p className="mt-1 text-[11px] text-gray-400">
                  Questo valore verrà copiato nella colonna contabile "Rif. ordine cliente".
                </p>
              </div>
            )}


            {type === 'intervento' && (
              <div>
                <label className="block text-gray-700 font-medium mb-1">
                  Materiale arrivato
                </label>
                <select
                  value={materialeArrivato}
                  onChange={(e) => setMaterialeArrivato(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-sky-500 bg-white"
                >
                  <option value="">Seleziona</option>
                  <option value="Si">Sì</option>
                  <option value="No">No</option>
                </select>
              </div>
            )}

            <div className="flex justify-end pt-2">
              <button
                type="submit"
                className="px-4 py-2 rounded-lg bg-emerald-600 text-white text-sm font-semibold hover:bg-emerald-700"
              >
                Crea e assegna
              </button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default LavorazioniCrea;
